import { format, isValid } from "date-fns";
import React from "react";
import { useParams } from "react-router-dom";
import getLocationSlug, {
  locationCenterReplacements,
} from "./utils/getLocationSlug";
import getStartAndEndDate from "./utils/getStartAndEndDate";
import { holidays } from "./utils/holidays";

interface Props {
  event: {
    "Event-Location": string;
    "Event-Name": string;
    "Holiday?": string;
  };
  type: string;
  locationIcons?: boolean;
  smallIcons?: boolean;
  noLocationTitle?: boolean;
  community: string;
  date?: Date;
}

export default function Event(props: Props) {
  // console.log("props.event", props.event);
  const match = useParams<{ community: string }>();
  const { startDate, endDate } = getStartAndEndDate(props.event);

  if (!isValid(startDate)) {
    console.log("props.event", props.event);
    return null;
  }

  // console.log("startDate", startDate);
  // console.log("endDate", endDate);

  let locationName = props.event["Event-Location"];
  const locationSlug = getLocationSlug(locationName, match.community);
  let startTime = !isNaN(startDate.getTime()) && format(startDate, "h:mm");

  let endTime = !isNaN(endDate.getTime()) && format(endDate, "h:mm aaaa");

  const classNames = ["event"];
  let image;

  if (locationCenterReplacements.includes(locationName)) {
    if (props.type === "month") {
      locationName = "Center";
    }
  }

  if (props.type === "week") {
    classNames.push("event--week");
    startTime = !isNaN(startDate.getTime()) && format(startDate, "h:mm");
    endTime = !isNaN(endDate.getTime()) && format(endDate, "h:mm aaaa");
  }

  if (props.type === "today") {
    classNames.push("event--today");
    startTime = format(startDate, "h:mm");
    endTime = !isNaN(endDate.getTime()) && format(endDate, "h:mm aaaa");
  }

  if (props.type === "month") {
    startTime = format(startDate, "h:mm");
    endTime = !isNaN(endDate.getTime()) && format(endDate, "h:mm");
  }

  if (
    (props.type === "month" || props.type === "week") &&
    holidays[props.event["Event-Name"]]
  ) {
    image = holidays[props.event["Event-Name"]];
  }

  if (props.type === "highlight") {
    startTime = format(startDate, "h:mm");
    endTime = !isNaN(endDate.getTime()) && format(endDate, "h:mm aaaa");
  }

  if (startTime && startTime.includes(":00")) {
    startTime = format(startDate, "h");
  }

  if (endTime && endTime.includes(":00")) {
    if (props.type === "month") {
      endTime = !isNaN(endDate.getTime()) && format(endDate, "h");
    } else {
      endTime = !isNaN(endDate.getTime()) && format(endDate, "h aaaa");
    }
  }

  if (props.type === "highlight") {
    return (
      <div className="event event--highlight">
        <div className="event__title">{props.event["Event-Name"]}</div>
        <div className="event__times">
          {format(startDate, "eeee, MMMM d")}
          <br />
          {startTime}–{endTime}
        </div>
      </div>
    );
  }

  if (image && props.event["Holiday?"]) {
    return (
      <div className={`month-image month-image--${props.type}`}>
        <img
          src={`/img/${image.file}`}
          alt=""
          className={`month-image__image ${image.className}`}
        />
      </div>
    );
  }

  return (
    <div className={classNames.join(" ")}>
      <div className="event__times">
        {startTime}–{endTime}
      </div>
      <div className="event__title">{props.event["Event-Name"]}</div>
      <div className={`event__location event__location--${locationSlug}`}>
        {props.locationIcons && (
          <div
            className={`legend__icon legend__icon--${locationSlug} ${
              props.smallIcons ? `legend__icon--small` : ""
            }`}
          />
        )}
        {!props.noLocationTitle && (
          <div className="event__location-name">{locationName}</div>
        )}
      </div>
    </div>
  );
}
